<template>
    <div class="search_item mb19">
        <div class="filter_category_box mr5">
            <el-select id="category" v-model="searchInputOption" class="my_filter select"
                       popper-class="select_style"
                       :popper-append-to-body="false">
                <el-option :value="'ina'" :label="$t('subject')"></el-option>
                <el-option :value="'hash'" :label="$t('hashtag')"></el-option>
                <el-option :value="'orni'" :label="$t('k_creator')"></el-option>
                <el-option :value="'cuni'" :label="$t('request_curator')"></el-option>
            </el-select>

        </div>
        <div class="search_input mypage_search_input">
            <el-input :placeholder="$t('st')" v-model="searchInput"
                      @input="setData('searchInput',searchInput)"
                      @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)">
            </el-input>
            <button class="search_btn mypage_search_btn"  @click="setFilterFunc(searchInputOption,searchInput)">
            </button>
        </div>
        <button class="search_filter_btn" @click="openFilter('item-filter-premium-my-filter')"></button>
    </div>
</template>

<script>
import curationUtil from "@/components/curation/curationUtil";
import util from "@/mixins/util";
import {curationStatus} from "@/service/curationService";

const {filterConfig} = curationUtil
export default {
    name: "CurationFilterReceiveLayout",
    mixins: [],
    components: {
    },
    inject: ['setFilter', 'setSort'],
    provide() {
        return{

        }
    },
    props: {
        filterData: {default: () => {}},
    },
    data() {
        return{
            sortOption: 'i.updated_at',
            searchInput: '',
            searchInputOption: 'ina',
            filterCategory: [],
            filterStatus: [],
            filterEdition: [],
            filterType: [],
            filterRequestDate: '',

            curationStatus: curationStatus,
            showPopover: false,
        }
    },
    beforeRouterEnter() {},
    created() {
        this.setterFilterDataInData();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
      openFilter(name) {
        this.$modal.show(name);
      },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    // this[classname] =
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setData(key, value) {
            this[key] = value;
        },
        openModal(name) {
            this.$modal.show(name);
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
